import React from 'react';
import Switch from 'react-switch';
import { auth } from '../../Api';
import { formatServerMessage } from '../../utils/serverErrors';

// On duty / Off duty for a guard (everyone is On duty unless switched Off). Saved at once, not with the
// form: each change is recorded with who made it and when. While Off duty the guard gets no duty alerts,
// rest reminders or pushes, and alerts that come due count neither as missed nor as answered.
// onDuty: the stored value; onChange(onDuty, history) is told after a save.
export function saveGuardOnDuty(guardId, onDuty) {
	return auth.setGuardOnDuty({ id: guardId, on_duty: onDuty }).then((res) => {
		if (res && res.data && res.data.code === 200) {
			return res.data;
		}
		throw new Error(formatServerMessage(res && res.data ? res.data.message : null, 'The change could not be saved.'));
	});
}

export function isOnDuty(value) {
	return !(value === 0 || value === '0' || value === false);
}

// The switch alone, for the guard list
export function GuardDutyToggle({ guardId, onDuty, onChange }) {
	const [saving, setSaving] = React.useState(false);
	const toggle = (checked) => {
		setSaving(true);
		saveGuardOnDuty(guardId, checked)
			.then((data) => onChange && onChange(data.on_duty, data.duty_history))
			.catch((error) => window.alert(error.message))
			.then(() => setSaving(false));
	};
	return (
		<span title={isOnDuty(onDuty) ? 'On duty: switch off to stop alerts for this guard' : 'Off duty: no alerts, rest reminders or pushes'}>
			<Switch onChange={toggle} checked={isOnDuty(onDuty)} disabled={saving} uncheckedIcon={false} checkedIcon={false}
				offColor="#ddd" height={20} width={40} />
		</span>
	);
}

// The switch with its label, for the guard edit form. The history of changes is on the Guard
// Information page (guardDutyHistory).
export default function GuardDutySwitch({ guardId, onDuty }) {
	const [value, setValue] = React.useState(onDuty);
	React.useEffect(() => {
		setValue(onDuty);
	}, [onDuty]);
	return (
		<div style={{ display: 'flex', alignItems: 'center' }}>
			<GuardDutyToggle guardId={guardId} onDuty={value} onChange={(saved) => setValue(saved)} />
			<span style={{ marginLeft: 10, fontWeight: 600 }}>{isOnDuty(value) ? 'On duty' : 'Off duty'}</span>
		</div>
	);
}
